@let loading = input.loading | parse: context | async;
@let icon = input.icon | parse: context | async;
@let disabled = input.disabled | parse: context | async;
@let text = input.text | parse: context | async;
@let diameter = 14;

@switch (input.style) {
  @case ('basic') {
    <button
      mat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('stroked') {
    <button
      mat-stroked-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('icon') {
    <button
      mat-icon-button
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="24" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('fab') {
    <button
      mat-fab
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
  @case ('mini-fab') {
    <button
      mat-mini-fab
      [color]="color"
      [disabled]="disabled"
      (click)="onClick($event)"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="tooltipPosition"
      [matBadge]="input.badge?.content | parse: context | async"
      [matBadgeColor]="input.badge?.color ?? 'primary'"
      [matBadgeDisabled]="input.badge?.disabled | parse: context | async"
      [matBadgeHidden]="input.badge?.hidden | parse: context | async"
      [matBadgeOverlap]="input.badge?.overlap | parse: context | async"
      [matBadgePosition]="input.badge?.position ?? 'above'"
      [matBadgeSize]="input.badge?.size ?? 'medium'"
      [matMenuTriggerFor]="input.menuWidgets ? menu : undefined"
    >
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" [diameter]="diameter" />
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (text) {
        <span>{{ text }}</span>
      }
      @if (input.contentWidget; as contentWidget) {
        <ng-container [dynamicWidget]="contentWidget" [context]="context" />
      }
    </button>
  }
}

<mat-menu #menu="matMenu">
  @for (widget of input.menuWidgets; track widget) {
    <ng-container [dynamicWidget]="widget" [context]="context" />
  }
</mat-menu>
